// src/services/apiService.js
import axios from "axios";
import axiosInstance from "./axiosInstance";

// Example recaptcha verification
export const verifyRecaptcha = async (recaptchaToken) => {
  try {
    const response = await axiosInstance.post("/auth/verify-recaptcha", { token: recaptchaToken });
    return response.data; // Return the response from backend
  } catch (error) {
    console.error("Error verifying reCAPTCHA:", error);
    throw error; // Handle this as needed
  }
};


export const searchRiderById = async (riderId, userId = null, ipAddress, locationName, userEmail = null, userPhone = null, userName = null, existant_id = true) => {
  try {
    const response = await axiosInstance.post(`/logs/search`, { 
      riderId, 
      userId, 
      ipAddress, 
      locationName, 
      userEmail, 
      userPhone, 
      userName,
      existant_id
    });
    return response.data;
  } catch (error) {
    console.error("Error searching for Safety ID:", error);
    throw error;
  }
};

export const getIpAddress = async () => {
  try {
    const response = await axios.get('https://api.ipify.org?format=json');
    return response.data.ip;
  } catch (error) {
    console.error("Error fetching IP address:", error);
    throw error;
  }
};